// components/ManagerSummaryCard.js
import React from "react";
import { Box, Typography, CircularProgress, Paper } from "@material-ui/core";

export default function ManagerSummaryCard({
    icon,
    value,
    label,
    progressColor = "#4caf50",
    progressValue = 75,
}) {
    return (
        <Paper
            elevation={3}
            style={{
                padding: 20,
                display: "flex",
                alignItems: "center",
                minWidth: 250,
                height: 120,
                borderRadius: 12,
            }}
        >
            {/* Círculo a la izquierda */}
            <Box position="relative" width={60} height={60} mr={2}>
                {/* Fondo gris */}
                <CircularProgress
                    variant="determinate"
                    value={100}
                    style={{
                        color: "#eee",
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                />
                {/* Progreso de color */}
                <CircularProgress
                    variant="determinate"
                    value={progressValue}
                    style={{
                        color: progressColor,
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                />
                {/* Ícono en el centro */}
                <Box
                    position="absolute"
                    top="50%"
                    left="50%"
                    style={{ transform: "translate(-50%, -50%)" }}
                >
                    {icon}
                </Box>
            </Box>

            {/* Texto a la derecha */}
            <Box display="flex" flexDirection="column" justifyContent="center">
                <Typography variant="h6">{value}</Typography>
                <Typography variant="body2" color="textSecondary">
                    {label}
                </Typography>
            </Box>
        </Paper>
    );
}
